import { useI18n } from "vue-i18n";

import { config } from "@/config";
import { MatomoHelper } from "@/helpers";
import { UserService } from "@/services";
import { type LeSelectOption, MatomoEventAction, MatomoEventCategory } from "@/types";

export function useSiteFooter(type: "simple" | "expanded") {
  const { t } = useI18n();

  const category = type === "simple" ? MatomoEventCategory.CompactFooter : MatomoEventCategory.ExpandedFooter;

  const languageSelectorOptions: LeSelectOption<string>[] = [
    { value: "da", text: t("le-footer-language-selector.danish") },
    { value: "de", text: t("le-footer-language-selector.german") },
    { value: "en", text: t("le-footer-language-selector.english") }
  ];

  const track = (label: string): void => {
    MatomoHelper.sendEvent(category, MatomoEventAction.ClickFooterButton, label);
  };

  const changeSiteLanguage = async (newLanguage: string): Promise<void> => {
    const translatedLanguage = languageSelectorOptions.find((option) => option.value === newLanguage)?.text;
    if (translatedLanguage) {
      track(`Picked language in language dropdown "${translatedLanguage}"`);
    }

    await UserService.setLanguage(newLanguage);

    const { language: currentLanguage } = config.app;

    const newPath = window.location.pathname.replace(currentLanguage, newLanguage) + window.location.search;
    window.location.replace(newPath);
  };

  const trackFooterButtonClick = (buttonName: string, quote = true): void => {
    let label = "Clicked ";
    if (quote) {
      label += `"${buttonName}"`;
    } else {
      label += buttonName;
    }

    track(label);
  };

  return {
    languageSelectorOptions,
    changeSiteLanguage,
    trackFooterButtonClick
  };
}
